<script lang="ts">
  import { QueryClient, QueryClientProvider } from '@tanstack/svelte-query';
  import { ApiError } from '../shared/api/errors';
  import { auth } from '../shared/auth/auth.svelte';
  import DiagBar from '../shared/diag/DiagBar.svelte';
  import { OfflineBanner, TestBanner, Toaster, UpdateBar } from '../shared/ui';
  import GlobalProgress from './GlobalProgress.svelte';
  import Routes from './Routes.svelte';

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // Client errors (403/404/validation) are answers, not glitches: do not retry them.
        retry: (count, error) => !(error instanceof ApiError && error.status < 500) && count < 2,
        refetchOnWindowFocus: false,
        // A request is always tried. TanStack otherwise pauses every query while `navigator.onLine`
        // is false and resumes only on the browser's `online` event; a phone that woke up after
        // that event fired (or whose flag is wrong) would leave pages loading for ever. A failed
        // call is a NetworkError and is retried; the offline banner says so (ADR-010).
        networkMode: 'always',
        // Every change reaches the page. TanStack otherwise reports only the fields read so far,
        // and a Svelte block that has not read one yet (`{#if !ready || q.isPending}`) would never
        // learn that the query finished.
        notifyOnChangeProps: 'all',
      },
      // Writes are never retried automatically and never queued offline (ADR-010).
      mutations: { retry: false, networkMode: 'online' },
    },
  });

  auth.restoreSession();
</script>

<QueryClientProvider client={queryClient}>
  <GlobalProgress />
  <TestBanner />
  <OfflineBanner />
  <UpdateBar />
  <Routes />
  <Toaster />
  <DiagBar />
</QueryClientProvider>
